export default class EncoderWavWorker {
    constructor(worker) {
        const code = worker.toString();
        const blob = new Blob(['('+code+')()']);
        return new Worker(window.URL.createObjectURL(blob));
    }
}